import customerStats from './customerStats';
import jobKpi from './jobKpi';
import customerKpi from './customerKpi';
import publicHolidays from './publicHolidays';

export default {
  customerStats,
  jobKpi,
  customerKpi,
  publicHolidays,
};
